import React from 'react'

const IconDisplayLeft = ({ width = '32', height = '22' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(0.000000, -5.000000)" fill="currentColor">
        <g transform="translate(0.000000, 5.000000)">
          <rect opacity="0.25" x="12" y="1" width="9" height="20" />
          <rect opacity="0.25" x="23" y="1" width="9" height="20" />
          <rect opacity="0.75" x="0" y="0" width="10" height="22" />
        </g>
      </g>
    </g>
  </svg>
)

export default IconDisplayLeft
